export default __webpack_public_path__ + "static/media/curvedChart.2e9e855c.svg";